import React, { useContext } from 'react';
import * as S from './style';
import BookImage from "~images/sem/main-section/book.png";
import FunnelImage from "~images/sem/main-section/funnel.png";
import NumberImg from '~images/sem/purchase/num.png';
import Image from '../../../../../app/js/components/loggedout/common/Image';
import MoneyBackStripe from '../MoneyBackStripe';
import LogoImage from "~images/loggedout/home/logo.png";

const PurchaseHeader = ({ offer, passwordScreen , showOfferTime }) => {
  const [validTime, setValidTime] = React.useState(null);
  const campaignBasedCustomMessaging = ["redemption", "splashlearn_giftup"].includes(localStorage.getItem("campaign_code"));

  if (offer && offer.validTill) {
    const x = setInterval(() => {
      const now = new Date().getTime();
      const distance = new Date(offer.validTill) - now;
      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      let validTime = `${days} day${days > 1 ? 's' : ''} ${hours} hr${hours > 1 ? 's' : ''} ${minutes} min`;
      if (distance < 0) {
        clearInterval(x);
        validTime = null;
      }
      setValidTime(validTime);
    }, 1000);
  }
  const headerTitle = campaignBasedCustomMessaging ? offer.planPageLeftHeaderText : (offer.planPageHeaderText || "Try SplashLearn for FREE");
  const subHeaderTitle = campaignBasedCustomMessaging ? offer.planPageLeftSubHeaderText : (offer.planPageSubHeaderText || `Get unlimited access for ${offer.trailDays} days. Cancel anytime`);

  return (
    <S.Wrapper passwordScreen={passwordScreen}>
      <S.LogoImage>
        <Image src={LogoImage} />
      </S.LogoImage>
      <S.HeaderTitle>{headerTitle}</S.HeaderTitle>
      <S.HeaderSubTitle>{subHeaderTitle}</S.HeaderSubTitle>
      {offer && !offer.showMoneyBack && !campaignBasedCustomMessaging && <MoneyBackStripe hideOnDesktop={true} bgColor='#212682' toolTipColor="#5659DD" fColor='#fff' iIconColor="#5659DD" textColor={true} />}
      {showOfferTime && offer && validTime && !campaignBasedCustomMessaging &&
        <S.OfferBanner>
          <S.OfferTime>{validTime}</S.OfferTime>
          <S.OfferText>{offer.offerText}</S.OfferText>
        </S.OfferBanner>
      }
      <S.ExtraInfoWrapper>
        <S.ExtraInfo>
          <S.InfoIcon firstInfoIcon={'img'}>
            <Image
              src={NumberImg}
              alt="4000"
            ></Image>
          </S.InfoIcon>
          <S.InfoIcon firstInfoIcon={'text'}>
            <p>4000+</p>
          </S.InfoIcon>
          <S.Info bottomText={true}>
            <p>
              Curriculum aligned skills
              </p>
          </S.Info>
        </S.ExtraInfo>
        <S.ExtraInfo>
          <S.InfoIcon>
            <Image
              src={BookImage}
              alt="Detailed Reports"
            ></Image>
          </S.InfoIcon>
          <S.Info>
            <p>
              Detailed Reports
              </p>
          </S.Info>
        </S.ExtraInfo>
        <S.ExtraInfo>
          <S.InfoIcon>
            <Image
              src={FunnelImage}
              alt="safe_image"
            ></Image>
          </S.InfoIcon>
          <S.Info>
            <p>
              Designed by Experts
              </p>
          </S.Info>
        </S.ExtraInfo>
      </S.ExtraInfoWrapper>
    </S.Wrapper>
  )
}
export default PurchaseHeader;